const config = {
	env: "local",
	// apiUrl: "http://localhost:5556/company/v1",
	apiUrl: "https://sitepro-api.onap.uk/company/v1",
	// apiUrl: "https://7cgqsbkf-5050.inc1.devtunnels.ms/admin",

};



export default config;
